import React from "react";
import FoundationImg from "./../../assets/images/concealer.png";
import FoundationImg2 from "./../../assets/images/concealer2.png";
import FoundationImg3 from "./../../assets/images/concealer3.png";
import FoundMini from "./../../assets/images/concealer_mini.png";
import "./concealer.css";
const Concealer = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="concealer" id="concealer">
      <div className="concealer_left">
        <div style={{ flex: 1 , padding: 0, margin: 0}}>

          <img src={FoundationImg2} alt=" " width="100%" height="100%" className="concealer_desktop" />
          <img src={FoundationImg3} alt=" " width="100%" className="concealer_mobile"/>
        </div>
        <div style={{ flex: 3, padding: 0, margin: 0 }}>
          <img src={FoundationImg} alt=" " width="100%" height="100%" />
        </div>
      </div>
      <div className="concealer_right">
        <div style={{ flex: 3 }}>
          <div className="concealer_heading">
            <div className="concealer_mini">
              <img src={FoundMini} alt=" " />
            </div>
            <p className="concealer_heading">CONCEALER <br /> Blender</p>
          </div>
          <p className="concealer_description">
          Designed to conceal and brighten the face apply concealer in a triangular shape underneath the eye and blend. Set with a powder so concealer won't crease.
          </p>
          <button className="primary_btn" onClick={()=> shopNow()}>Shop Now</button>
        </div>
        <div style={{ flex: 1 }} className="concealer_content_spacer"></div>
      </div>
    </div>
  );
};

export default Concealer;
